module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Semibold.5a785cc0.woff2";